// // import { Link } from "react-router-dom";
// // import { Sparkles, ArrowRight } from "lucide-react";

// // export default function Quotations() {
// //   return (
// //     <div>
// //       <h1 className="text-3xl font-extrabold text-gray-900">Quotations</h1>
// //       <p className="text-gray-600 mt-1 mb-6">Live module preview</p>

// //       <div className="bg-gray-50 border border-gray-100 rounded-2xl px-6 py-16 flex flex-col items-center text-center">
// //         <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mb-6">
// //           <Sparkles className="w-6 h-6 text-white" />
// //         </div>

// //         <h2 className="text-2xl font-extrabold text-gray-900 mb-4">Quotations</h2>

// //         <p className="text-gray-500 max-w-xl mb-8">
// //           This module is part of the ProtoHub MVP scaffold — data schema,
// //           workflows and role permissions are wired. Full UI is being rolled
// //           out module-by-module across the next releases.
// //         </p>

// //         <div className="flex flex-wrap items-center justify-center gap-3">
// //           <Link
// //             to="/app/dashboard"
// //             className="bg-white border border-gray-200 text-gray-900 font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-gray-100 transition"
// //           >
// //             Innovator Home
// //           </Link>
          
// //            <a href="#apic-admin"
// //             className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold text-sm px-5 py-2.5 rounded-xl hover:opacity-90 transition"
// //           >
// //             APIC Admin
// //             <ArrowRight className="w-4 h-4" />
// //           </a>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }



// import { useState } from "react";
// import { Search } from "lucide-react";
// import QuotationCard from "../components/modules/quotations/QuotationCard";
// import quotationsData from "../data/quotationsData";

// const filters = ["All", "Pending Review", "Approved", "Rejected", "Expired"];

// export default function Quotations() {
//   const [query, setQuery] = useState("");
//   const [activeFilter, setActiveFilter] = useState("All");

//   const filtered = quotationsData.filter((q) => {
//     const matchesFilter = activeFilter === "All" || q.status === activeFilter;
//     const matchesQuery =
//       q.projectTitle.toLowerCase().includes(query.toLowerCase()) ||
//       q.id.toLowerCase().includes(query.toLowerCase());
//     return matchesFilter && matchesQuery;
//   });

//   const pendingCount = quotationsData.filter((q) => q.status === "Pending Review").length;
//   const totalApprovedValue = quotationsData
//     .filter((q) => q.status === "Approved")
//     .reduce((sum, q) => sum + q.amount, 0);

//   return (
//     <div>
//       <h1 className="text-3xl font-extrabold text-gray-900">Quotations</h1>
//       <p className="text-gray-600 mt-1 mb-6">
//         Review and approve cost estimates for your prototype requests.
//       </p>

//       {/* Summary stats */}
//       <div className="grid sm:grid-cols-3 gap-4 mb-6">
//         <div className="bg-white border border-gray-100 rounded-2xl p-5">
//           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL QUOTATIONS</p>
//           <p className="text-2xl font-extrabold text-gray-900">{quotationsData.length}</p>
//         </div>
//         <div className="bg-white border border-gray-100 rounded-2xl p-5">
//           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">AWAITING YOUR REVIEW</p>
//           <p className="text-2xl font-extrabold text-orange-600">{pendingCount}</p>
//         </div>
//         <div className="bg-white border border-gray-100 rounded-2xl p-5">
//           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">APPROVED VALUE</p>
//           <p className="text-2xl font-extrabold text-gray-900">
//             ₹{totalApprovedValue.toLocaleString("en-IN")}
//           </p>
//         </div>
//       </div>

//       {/* Search + filters */}
//       <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6">
//         <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 mb-4">
//           <Search className="w-4 h-4 text-gray-400" />
//           <input
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             placeholder="Search by project name or quotation ID..."
//             className="w-full bg-transparent text-sm focus:outline-none"
//           />
//         </div>

//         <div className="flex flex-wrap gap-2">
//           {filters.map((f) => {
//             const isActive = activeFilter === f;
//             return (
//               <button
//                 key={f}
//                 type="button"
//                 onClick={() => setActiveFilter(f)}
//                 className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
//                   isActive
//                     ? "bg-indigo-600 border-indigo-600 text-white"
//                     : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
//                 }`}
//               >
//                 {f}
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* List */}
//       {filtered.length > 0 ? (
//         <div className="space-y-5">
//           {filtered.map((q) => (
//             <QuotationCard key={q.id} quotation={q} />
//           ))}
//         </div>
//       ) : (
//         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
//           No quotations match your search.
//         </div>
//       )}
//     </div>
//   );
// }





import React, { useState } from "react";
import "../../Users/components/modules/SalesManagment/SalesManagment.css";
import SalesManagmentall from "../../Users/components/modules/SalesManagment/SalesManagmentall.jsx"
import Salsemannger from "../../Users/components/modules/SalesManagment/Salsemannger.jsx";
// import LeadsOrders from "../Ordermanagment/Caterings/LeadsOrders.js";

/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

/* ---------- Main Company Component ---------- */
const Quotations = () => {

  const tabs = [
    // { id: 8, name: "Leads Orders", component: () => <LeadsOrders title="LeadsOrders" /> },

    { id: 9, name: "Sales Executive", component: () => <SalesManagmentall title="Newdashbord" /> },
    { id: 7, name: "Manager", component: () => <Salsemannger title="Sourcing" /> },
  
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">

      {/* 🔹 Inline CSS */}
      <style>{`
        .company-scroll-container {
          position: static;
          background: #fff;
          overflow-x: auto;
        }

        .company-buttons-row {
          display: flex;
          flex-wrap: nowrap;
          gap: 8px;
        }

        .company-button {
          padding: 8px 16px;
          border: none;
          background: #f0f0f0;
          cursor: pointer;
          border-radius: 6px;
          white-space: nowrap;
          font-size: 14px;
        }

        .company-button.active {
          background: #4f46e5;
          color: #fff;
        }

        .dummy-box{
          padding:40px;
          text-align:center;
        }

        /* Desktop Sticky */
        @media (min-width: 769px) {
          .company-scroll-container {
            position: sticky;
            top: 0;
          }
        }
      `}</style>

      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>

    </div>
  );
};

export default Quotations;